import { BaseApi } from './base.api.js';
import { ApiError } from '../errors/api-error.js';

export class ApplicationTrackingApi extends BaseApi {
    constructor(client) {
        super(client, '/application-tracking');
    }

    async promoteToDsr(id, data = {}) {
        try {
            const response = await this.client.post(`${this.basePath}/${id}/promote-to-dsr`, data);
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }
}
